<quill-editor
  [ngModel]="control.value"
  (ngModelChange)="onChange($event)"
  (onBlur)="control.markAsTouched()"
  [styles]="{ width: '100%', borderBottomLeftRadius: '0.5rem', borderBottomRightRadius: '0.5rem' }"
  [sanitize]="true"
/>
